/* global vhyPop */

import EventEmitter from 'events'
import ensureZepto from 'amkit3-modules/utils/ensure-zepto'
import { getLogger } from 'amkit3-modules/utils/log4js'

import PlaybackEvent from 'amkit3-modules/v/playbacks/playback-event'
import UIEvent from 'amkit3-modules/v/ui/ui-event'
import HuyaUIEvent from 'amkit3-modules/v/ui/huya/huya-ui-event'
import DanmuEvent from 'amkit3-modules/v/danmu/danmu-event'
import { DEFAULT_DANMU_TYPE } from 'amkit3-modules/v/danmu/danmu-config'
import { timeList, liveDanmuList, add } from 'amkit3-modules/utils/services/huya/danmu'
import cookie from 'amkit3-modules/utils/cookie'
import { getVideoLiveBarrage } from 'amkit3-modules/utils/taf/api/getVideoLiveBarrage'

import HuyaDanmuComments from './comments'
import Toast from 'amkit3-modules/components/huya/Toast'

const MAX_TIME_DELTA = 2

const LIVE_DANMU_INTERVAL = 10
const VIDEO_DANMU_INTERVAL = 10

const logger = getLogger('v/danmu/huya')

class HuyaDanmu extends EventEmitter {
  constructor(container, options, player) {
    super()

    ensureZepto((err, $) => {
      if (err) {
        logger.warn('no zepto supported, err[', err, ']')
      } else {
        this.init($, container, options, player)
      }
    })
  }
  init($, container, options, player) {
    if (options.no_danmu || options.no_ui)
      return logger.debug('options.no_danmu is', options.no_danmu, 'skip')
    this.initDanmu($, container, options, player)
  }
  initDanmu($, container, options, player) {
    logger.debug('huya danmu init, container[', container, '], options[', options, ']')
    this.$ = $
    this.$container = this.$(container)
    this.player = player

    this.commentMap = {}
    this.pushed = {}
    this.comments = new HuyaDanmuComments(this.$, this.$container)
    // this.enable = true
    this.currentTime = NaN

    this.danmuType = DEFAULT_DANMU_TYPE

    this.nextBeginTime = NaN // 录像弹幕下一下获取时间
    this.nextBeginTime2 = NaN // 直播弹幕下一下获取时间

    this.clearTime = 0 // 录像弹幕获取时间间隔
    this.clearTime2 = 0 // 直播弹幕获取时间间隔

    var fetching = false // 录像弹幕请求状态
    var fetching2 = false // 直播弹幕请求状态

    let liveErrorTime = 0
    let videoErrorTime = 0

    this.player.on(PlaybackEvent.PLAYING, () => {
      this.comments.resume()
    })
    this.player.on(PlaybackEvent.ENDED, () => {
      this.comments.clear()
      this.comments.pause()
      this.comments.clearFinishComments()
      this.nextBeginTime = NaN
      this.commentMap = {}
      this.pushed = {}
      this.player.once(PlaybackEvent.PLAYING, () => {
        this.comments.clear()
        this.nextBeginTime = NaN
        this.nextBeginTime2 = NaN
        this.commentMap = {}
        this.pushed = {}
      })
    })

    this.player.on(PlaybackEvent.TIME_UPDATE, () => {
      var currentTime = player.getCurrentTime()

      this.currentTime = currentTime
      // console.log('currentTime:',currentTime)
      // 1. 根据时间获取弹幕列表
      if (
        this.danmuType.indexOf('video') >= 0 &&
        this.comments.enable &&
        !fetching &&
        (isNaN(this.nextBeginTime) ||
          (this.nextBeginTime > 0 && currentTime * 1000 > this.nextBeginTime - 10000))
      ) {
        fetching = true
        ;(_t => {
          timeList(
            this.player.getVid(),
            this.nextBeginTime || Math.round(currentTime) * 1000,
            (err, data) => {
              fetching = false

              if (_t !== this.clearTime) {
                logger.warn(
                  'disgard fetch result, _t',
                  _t,
                  'is not equal this.clearTime',
                  this.clearTime,
                )
                // 重试
                this.nextBeginTime =
                  Math.round(player.getCurrentTime() + videoErrorTime * VIDEO_DANMU_INTERVAL) * 1000
                videoErrorTime = videoErrorTime + 1
              } else if (err) {
                // 重试
                this.nextBeginTime =
                  Math.round(player.getCurrentTime() + videoErrorTime * VIDEO_DANMU_INTERVAL) * 1000
                videoErrorTime = videoErrorTime + 1
              } else if (!data) {
                // 没有弹幕了
                this.nextBeginTime = -1
                videoErrorTime = 0
              } else {
                // data = { nextBeginTime: 7001}
                // const list = Array.from({length: 100}).map(() => {
                //   return {
                //     color: "-1",
                //     danmuType: "video",
                //     id: Math.random()*10000000000,
                //     mode: "0",
                //     nick: "",
                //     playTime: 2,
                //     size: "4",
                //     submitTime: "09-25 21:37",
                //     text: "111111",
                //   }
                // });
                this.nextBeginTime = data.nextBeginTime
                data.list.forEach(commentItem => {
                  if (!this.commentMap[String(commentItem.playTime)]) {
                    this.commentMap[String(commentItem.playTime)] = []
                  }
                  if (!this.pushed[String(commentItem.id)]) {
                    this.pushed[String(commentItem.id)] = true
                    this.commentMap[String(commentItem.playTime)].push(
                      Object.assign(commentItem, { danmuType: 'video' }),
                    )
                  }
                })
                videoErrorTime = 0
              }
            },
          )
        })(this.clearTime)
      }

      if (
        this.danmuType.indexOf('live') >= 0 &&
        options.isShowLiveDanmu &&
        this.comments.enable &&
        !fetching2 &&
        (isNaN(this.nextBeginTime2) ||
          (this.nextBeginTime2 > 0 && currentTime * 1000 > this.nextBeginTime2 - 200))
      ) {
        // 视频弹幕已经包括直播弹幕，所以不需要再获取直播弹幕
        return
        fetching2 = true

        //弹幕接口改调taf start
        const prevClearTime2 = this.clearTime2
        const endDuration = Math.round(currentTime + LIVE_DANMU_INTERVAL)
        getVideoLiveBarrage({
          vid: Number(this.player.getVid()),
          startDuration: this.nextBeginTime2
            ? Math.round(this.nextBeginTime2 / 1000)
            : Math.round(currentTime),
          endDuration: Math.round(currentTime + LIVE_DANMU_INTERVAL),
        })
          .then(res => {
            if (prevClearTime2 !== this.clearTime2) {
              throw new Error('时间错位')
            }
            this.nextBeginTime2 = endDuration * 1000
            res.list.value.forEach((commentItem, index) => {
              commentItem = {
                uid: Number(commentItem.uid),
                anchorUid: commentItem.pid,
                playTime: commentItem.relativeTime,
                createTime: commentItem.sendTime * 1000,
                text: commentItem.content,
                danmuType: 'live',
              }
              if (!this.commentMap[String(commentItem.playTime)]) {
                this.commentMap[String(commentItem.playTime)] = []
              }
              if (!this.pushed[String(commentItem.createTime) + index]) {
                this.pushed[String(commentItem.createTime) + index] = true
                this.commentMap[String(commentItem.playTime)].push(commentItem)
              }
            })
            liveErrorTime = 0
          })
          .catch(err => {
            console.error(err)
            this.nextBeginTime2 =
              Math.round(player.getCurrentTime() + liveErrorTime * LIVE_DANMU_INTERVAL) * 1000
            liveErrorTime = liveErrorTime + 1
          })
          .finally(() => {
            fetching2 = false
          })
        //弹幕接口改调taf end

        // ;(_t => {
        //   liveDanmuList(this.player.getVid(), this.nextBeginTime2 ? this.nextBeginTime2/1000 : Math.round(currentTime), Math.round(currentTime + LIVE_DANMU_INTERVAL), (err, data) => {
        //     fetching2 = false

        //     if (_t !== this.clearTime2) {
        //       logger.warn('disgard fetch result, _t', _t, 'is not equal this.clearTime', this.clearTime2)
        //       // 重试
        //       this.nextBeginTime2 =
        //         Math.round(
        //           player.getCurrentTime() + liveErrorTime * LIVE_DANMU_INTERVAL
        //         ) * 1000;
        //       liveErrorTime = liveErrorTime + 1;
        //     } else if (err) {
        //       // 重试
        //       this.nextBeginTime2 =
        //         Math.round(
        //           player.getCurrentTime() + liveErrorTime * LIVE_DANMU_INTERVAL
        //         ) * 1000;
        //       liveErrorTime = liveErrorTime + 1;
        //     } else if (!data) {
        //       // 没有弹幕了
        //       this.nextBeginTime2 = -1;
        //       liveErrorTime = 0;
        //     } else {
        //       this.nextBeginTime2 =  (data.nextBeginTime || Math.round(currentTime + LIVE_DANMU_INTERVAL)) * 1000
        //       logger.info('===================danmu=============================', data)
        //       data.list.forEach((commentItem, index) => {
        //         if (!this.commentMap[String(commentItem.playTime)]) {
        //           this.commentMap[String(commentItem.playTime)] = []
        //         }
        //         if (!this.pushed[String(commentItem.createTime)+index]) {
        //           this.pushed[String(commentItem.createTime)+index] = true
        //           this.commentMap[String(commentItem.playTime)].push(Object.assign(commentItem, { danmuType: 'live' }))
        //         }
        //       })
        //       liveErrorTime = 0;
        //     }
        //   })
        // })(this.clearTime2)
      }

      // 2. 根据时间弹出弹幕
      Object.keys(this.commentMap).forEach(i => {
        const k = Number(i)
        if (k < currentTime) {
          var commentItems = this.$.extend([], this.commentMap[String(k)], true)
          if (Math.abs(Number(k) - currentTime) < MAX_TIME_DELTA) {
            this.comments.push(commentItems)
          }
          logger.info('时间弹幕映射：', commentItems)
          delete this.commentMap[String(k)]
        }
      })

      // Object.keys(this.commentMap).map(Number).filter(k => k < currentTime).forEach(k => {
      //   var commentItems = this.$.extend([], this.commentMap[String(k)], true)
      //   if (Math.abs(Number(k) - currentTime) < MAX_TIME_DELTA) {
      //     this.comments.push(commentItems)
      //   }
      //   delete this.commentMap[String(k)]
      // })
    })
    this.player.on(UIEvent.PAUSE_BUTTON_CLICK, () => this.comments.pause())
    this.player.on(UIEvent.PLAY_BUTTON_CLICK, () => this.comments.resume())

    this.player.on(UIEvent.TIME_CHANGE, () => {
      this.comments.clear()
      this.nextBeginTime = NaN
      this.nextBeginTime2 = NaN
      this.pushed = {}
      this.commentMap = {}
      this.clearTime = new Date().valueOf()
      this.clearTime2 = new Date().valueOf()
    })
    this.player.on(HuyaUIEvent.DEFINITION_CHANGE, () => {
      this.comments.clear()
      this.nextBeginTime = Math.floor((this.currentTime + 1) * 1000)
      this.nextBeginTime2 = Math.floor((this.currentTime + 1) * 1000)
      this.pushed = {}
      this.commentMap = {}
      this.clearTime = new Date().valueOf()
      this.clearTime2 = new Date().valueOf()
    })

    this.player.on(DanmuEvent.ENABLE, () => {
      if (this.comments.enable) return
      this.comments.enable = true
      this.nextBeginTime = NaN
      this.nextBeginTime2 = NaN
      this.commentMap = {}
      this.pushed = {}
      // this.comments.resume()
    })
    this.player.on(DanmuEvent.DISABLE, () => {
      if (!this.comments.enable) return
      this.comments.enable = false
      this.nextBeginTime = NaN
      this.nextBeginTime2 = NaN
      this.commentMap = {}
      this.pushed = {}
      this.comments.clear()
      this.clearTime = new Date().valueOf()
      this.clearTime2 = new Date().valueOf()
    })
    this.player.on(DanmuEvent.SIGNIN, () => {
      if (global.TT) {
        global.TT.login.login()
      }
    })
    this.player.on(DanmuEvent.SIGNUP, () => {
      if (global.TT) {
        global.TT.login.register()
      }
    })

    /**
     * 弹幕相关操作
     */
    this.player.on(DanmuEvent.POSITION, position => this.comments.setPosition(position))
    this.player.on(DanmuEvent.SIZE, size => this.comments.setFontSize(size))
    this.player.on(DanmuEvent.TYPE, type => {
      console.log('danmu-comment type', type)
      this.danmuType = type
      this.comments.setDanmuType(type)
    })
    this.player.on(DanmuEvent.OPACITY, opacity => {
      console.log('danmu-comment', opacity)
      this.comments.setOpacity(opacity)
    })
    this.player.on(DanmuEvent.OPACITY_END, opacity => {
      this.comments.setCookieOpacity(opacity)
    })

    this.player.on(DanmuEvent.SUBMIT, () => {
      var vid = this.player.getVid()
      var playTime = Math.floor(this.player.getCurrentTime())
      var content = this.player.getDanmuContent()

      logger.info('==============DanmuEvent.SUBMIT===========:', content)

      var size = 0
      var color = 0
      var mode = 0
      var deathTime = playTime + 10

      add(vid, playTime, content, size, color, mode, deathTime, (err, detail, optStatus) => {
        if (err) {
          Toast.show({
            content: err.message || '弹幕发送失败，请稍后重试',
            container: this.$container[0],
          })
        } else {
          if (this.comments.enable) {
            this.comments.push([
              {
                id: detail.id,
                playTime: detail.playTime,
                text: detail.text,
                highlight: true,
                danmuType: 'video',
              },
            ])
          }
          if (typeof global.getList === 'function') {
            global.getList(this.player.getVid())
          }
        }
        if (optStatus === 1) {
          try {
            vhyPop('vhy-pop1')
          } catch (error) {}
        }
        this.player.danmuSubmitCountdown()
      })
    })

    if (global.TT) {
      global.TT.getUserInfo(data => {
        this.player.setDanmuValid(!!data && data.isLogined)
      })
    } else {
      this.player.setDanmuValid(!!cookie.get('username') || !!cookie.get('udb_uid'))
    }
  }
}

export default HuyaDanmu
